import { DICTIONARY, FACTORY, FULL_SERVICE } from '../types';
// ==============================|| Statistics ||============================== //
const initialState = {
  factoryOptions: [],
  unitOptions: [],
  billTypeOptions: [],
  sendTypeOptions: [],
  sendAllTypeOptions: [],
  mailStatusOptions: [],
  buildOptions: [],
  floorOptions: [],
  officeOptions: [],
  tenancyOptions: [],
  rentTypeOptions: [],
  needTimeTypeOptions: [],
  applyStatusOptions: [],
  waitStatusOptions: [],
  signActionOptions: [],
  changeTypeOptions: [],
  changeStatusOptions: [],
  personnel: {
    list: [],
    total: 0,
    page: 1,
    rowsPerPage: 10,
    pages: 10,
  },
};

const shareReducer = function (state = initialState, action) {
  switch (action.type) {
    case FACTORY.List: {
      return {
        ...state,
        factoryOptions: action.payload
      };
    }
    case FACTORY.Unit: {
      return {
        ...state,
        unitOptions: action.payload
      };
    }
    case FACTORY.Person: {
      return {
        ...state,
        personnel: { ...action.payload }
      };
    }
    case DICTIONARY.BillType: {
      return {
        ...state,
        billTypeOptions: action.payload
      };
    }
    case DICTIONARY.SendType: {
      return {
        ...state,
        sendTypeOptions: action.payload
      };
    }
    case DICTIONARY.SendAllType: {
      return {
        ...state,
        sendAllTypeOptions: action.payload
      };
    }
    case DICTIONARY.MailStatus: {
      return {
        ...state,
        mailStatusOptions: action.payload
      };
    }
    // 廠區樓棟
    case FACTORY.Build: {
      return {
        ...state,
        buildOptions: action.payload
      };
    }
    
     // 廠區樓層
    case FACTORY.Floor: {
      return {
        ...state,
        floorOptions: action.payload
      };
    }
    // 资源类型
    case DICTIONARY.OfficeType: {
      return {
        ...state,
        officeOptions: action.payload
      };
    }
    case DICTIONARY.TenancyType: {
      return {
        ...state,
        tenancyOptions: action.payload
      };
    }
    // 承租類型
    case DICTIONARY.RentType: {
      return {
        ...state,
        rentTypeOptions: action.payload
      };
    }
    case DICTIONARY.NeedTimeType: {
      return {
        ...state,
        needTimeTypeOptions: action.payload
      };
    }
    // 申請狀態
    case DICTIONARY.ApplyStatus: {
      return {
        ...state,
        applyStatusOptions: action.payload
      };
    }
    // 候補狀態
    case DICTIONARY.WaitStatus: {
      return {
        ...state,
        waitStatusOptions: action.payload
      };
    }
    // 變更狀態
    case DICTIONARY.ChangeStatus: {
      return {
        ...state,
        changeStatusOptions: action.payload
      };
    }
    // 簽核動作
    case DICTIONARY.BpmSignAction: {
      return {
        ...state,
        signActionOptions: action.payload
      };
    }
    // 變更類型
    case DICTIONARY.ChangeType: {
      return {
        ...state,
        changeTypeOptions: action.payload
      };
    }
    default: {
      return state;
    }
  }
};

export default shareReducer;
